import React from 'react';
import { Route, Routes } from 'react-router-dom';
import Header from './components/Header';
import Services from './components/Services';
import Footer from './components/Footer';
import HomePage from './pages/HomePage';
import NotFound from './components/NotFound';
import About from './components/About';
import Contact from './components/Contact';
import Blogs from './components/Blogs';
import ProductDetails from './components/ProductDetails';
import Product from './components/Product';
import SEO from './components/SEO';
import DeckleMatchingGuide from './components/blogs/DeckleMatchingGuide';
import ReduceTrimWaste from './components/blogs/ReduceTrimWaste';
import MistakesInReelSlitting from './components/blogs/MistakesInReelSlitting';
import WhyDeckleMatchingOptimization from './components/blogs/WhyDeckleMatchingOptimization';
import DeckleProImprovesYield from './components/blogs/DeckleProImprovesYield';
import DeckleMatchingSoftwareFeatures from './components/blogs/DeckleMatchingSoftwareFeatures';
import ManualVsSoftwareDeckleMatching from './components/blogs/ManualVsSoftwareDeckleMatching';
import GSMDeckleKnifeLimits from './components/blogs/GSMDeckleKnifeLimits';
import HowReduced18PercentWaste from './components/blogs/HowReduced18PercentWaste';
import DotNet10 from './components/blogs/DotNet10';
import AngularMostReliableFramework from './components/blogs/AngularMostReliableFramework';
import NodeIsBackbone from './components/blogs/NodeIsBackbone';
import ArchitectingAngularApplications from './components/blogs/ArchitectingAngularApplications';
import WhySaasProductsSlowDown from './components/blogs/WhySaaSProductsSlowDown';
import ModernizingLegacyWithDotNetCore from './components/blogs/ModernizingLegacyWithDotNetCore';
import EngineeringPartnerVsHiring from './components/blogs/EngineeringPartnerVsHiring';
import FoundersGuideReliableSoftware from './components/blogs/FoundersGuideReliableSoftware';
import TeamMemberAryanHalapara from './components/team/TeamMemberAryanHalapara';
import LocalSoftwareSEO from './components/LocalSoftwareSEO';
import DeckleSoftwareAEO from './components/DeckleSoftwareAEO';

const App = () => {
  const servicesSchema = {
    "@context": "https://schema.org",
    "@type": "ItemList",
    "name": "Anmatics software engineering services",
    "itemListElement": [
      "SaaS Product Development",
      "Enterprise Web Applications",
      "AI Workflow Automation",
      "Legacy System Modernization",
      "Cloud & API Engineering",
      "Product Maintenance & Scaling"
    ].map((name, index) => ({
      "@type": "ListItem",
      "position": index + 1,
      "item": {
        "@type": "Service",
        "name": name,
        "provider": {
          "@type": "Organization",
          "name": "Anmatics Technologies",
          "url": "https://www.anmatics.com"
        }
      }
    }))
  };

  return (
    <div>
      <Header />
      <main id="main">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/home" element={<HomePage />} />
          <Route path="/about" element={<><SEO title="About Anmatics | Enterprise Software Engineering Company" description="Learn how Anmatics helps companies build, modernize, automate, and scale reliable SaaS platforms, enterprise applications, AI workflows, and cloud-ready systems." path="/about" /><About /></>} />
          <Route path="/services" element={<><SEO title="Software Engineering Services | SaaS, AI & Modernization | Anmatics" description="Explore Anmatics services for SaaS product development, enterprise web applications, AI workflow automation, legacy modernization, cloud APIs, and product scaling." path="/services" jsonLd={servicesSchema} /><Services /></>} />
          <Route path="/products" element={<><SEO title="Anmatics Products | DecklePro for Paper Mill Optimization" description="Explore products built by Anmatics, including DecklePro, deckle matching and reel slitting optimization software for kraft paper mills." path="/products" image="https://www.anmatics.com/decklepro_banner.png" /><Product /></>} />
          <Route path="/contact" element={<><SEO title="Book a Technical Consultation | Contact Anmatics" description="Contact Anmatics to discuss SaaS product development, AI workflow automation, enterprise applications, APIs, cloud systems, or legacy modernization." path="/contact" /><Contact /></>} />
          <Route path="/software-development-company-in-morbi" element={<LocalSoftwareSEO location="morbi" />} />
          <Route path="/it-company-in-morbi" element={<LocalSoftwareSEO location="morbi" canonicalPath="/software-development-company-in-morbi" />} />
          <Route path="/software-development-company-in-rajkot" element={<LocalSoftwareSEO location="rajkot" />} />
          <Route path="/it-company-in-rajkot" element={<LocalSoftwareSEO location="rajkot" canonicalPath="/software-development-company-in-rajkot" />} />
          <Route path="/software-development-company-in-gujarat" element={<LocalSoftwareSEO location="gujarat" />} />
          <Route path="/it-company-in-gujarat" element={<LocalSoftwareSEO location="gujarat" canonicalPath="/software-development-company-in-gujarat" />} />
          <Route path="/software-development-company-in-india" element={<LocalSoftwareSEO location="india" />} />
          <Route path="/it-company-in-india" element={<LocalSoftwareSEO location="india" canonicalPath="/software-development-company-in-india" />} />
          <Route path="/blogs" element={<Blogs />} />
          <Route path="/blogs/deckle-matching-guide" element={<DeckleMatchingGuide />} />
          <Route path="/blogs/reduce-trim-waste" element={<ReduceTrimWaste />} />
          <Route path="/blogs/mistakes-in-reel-slitting" element={<MistakesInReelSlitting />} />
          <Route path="/blogs/deckle-matching-optimization" element={<WhyDeckleMatchingOptimization />} />
          <Route path="/blogs/manual-vs-software-deckle-matching" element={<ManualVsSoftwareDeckleMatching />} />
          <Route path="/blogs/gsm-deckle-knife-limits" element={<GSMDeckleKnifeLimits />} />
          <Route path="/blogs/decklepro-improves-yield" element={<DeckleProImprovesYield />} />
          <Route path="/blogs/deckle-matching-software-features" element={<DeckleMatchingSoftwareFeatures />} />
          <Route path="/blogs/how-reduced-18-percent-waste" element={<HowReduced18PercentWaste />} />
          <Route path="/blogs/dotnet-10-business-solutions" element={<DotNet10 />} />
          <Route path="/blogs/angular-most-reliable-framework" element={<AngularMostReliableFramework />} />
          <Route path="/blogs/node-is-backbone" element={<NodeIsBackbone />} />
          <Route path="/blogs/architecting-angular-applications" element={<ArchitectingAngularApplications />} />
          <Route path="/blogs/why-saas-products-slow-down" element={<WhySaasProductsSlowDown />} />
          <Route path="/blogs/modernizing-legacy-with-dotnet-core" element={<ModernizingLegacyWithDotNetCore />} />
          <Route path="/blogs/engineering-partner-vs-hiring" element={<EngineeringPartnerVsHiring />} />
          <Route path="/blogs/founders-guide-reliable-software" element={<FoundersGuideReliableSoftware />} />
          <Route path="/deckle-matching-software-for-paper-mills" element={<DeckleSoftwareAEO />} />
          <Route path="/deckle-matching-software" element={<ProductDetails />} />
          <Route path="/decklepro" element={<ProductDetails canonicalPath="/deckle-matching-software" />} />
          <Route path="/deckle-pro" element={<ProductDetails canonicalPath="/deckle-matching-software" />} />
          <Route path="/paper-mill-optimization-software" element={<ProductDetails canonicalPath="/deckle-matching-software" />} />
          <Route path="/reel-slitting-optimization-software" element={<ProductDetails canonicalPath="/deckle-matching-software" />} />
          <Route path="/product-details" element={<ProductDetails canonicalPath="/deckle-matching-software" />} />
          <Route path="/team/aryan-halapara" element={<TeamMemberAryanHalapara />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </main>
      <Footer />
    </div>
  );
};

export default App;
